import { createFileRoute } from '@tanstack/react-router';

import { AdminFeatureFlagsView } from 'src/sections/admin/feature-flags/admin-feature-flags-view';

export const Route = createFileRoute('/admin-skidog/feature-flags')({
  component: AdminFeatureFlagsPage,
});

function AdminFeatureFlagsPage() {
  return <AdminFeatureFlagsView />;
}
